import { useRef, useState } from 'react';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { BreadCrumb } from 'primereact/breadcrumb';
import { MenuItem } from 'primereact/menuitem';
import TeachersDataTable from '../components/Teachers/TeachersDataTable';
import ClassWizardNewTeacherDialog from '../components/ClassesRoster/ClassesRosterWizard/ClassWizardNewTeacherDialog';
import { useAppSelector } from '../redux/hooks';
import { selectUser } from '../redux/reducers/userSlice';
import { Roles } from '../models/User';
import { useSideNavActive } from '../components/LayoutWrapper/SideNavLayoutContext';
import { Toast } from 'primereact/toast';
import { CompleteUser } from '../custom-hooks/useGetUsersBySite';
import { ConfirmDialog } from 'primereact/confirmdialog';

const Teachers = () => {
  const navigate = useNavigate();
  const sideNavActive = useSideNavActive();
  const userRedux = useAppSelector(selectUser);
  const toast = useRef<Toast>(null);
  const [refetchTeacherKey, setRefetchTeacherKey] = useState(0);
  const [selectedTeacher, setSelectedTeacher] = useState<CompleteUser | undefined>();

  const [showEnrollUserDialog, setShowEnrollUserDialog] = useState<boolean>(false);

  const breadcrumbItems: MenuItem[] = [
    { label: 'Set Up', command: () => navigate('/setting-up') },
    { label: 'Teachers & Admins' },
  ];
  const home: MenuItem = { icon: 'nc_icon-nc_home icon-sm', command: () => navigate('/') };

  const adminRoles = [Roles.NETWORK_ADMIN, Roles.SITE_ADMIN];
  const isAdmin = adminRoles.some(role => userRedux?.roles?.some(userRole => userRole?.name === role));

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <div className="grid nc_content-frame nc_page-inner flex flex-column pb-8">
        <ConfirmDialog />
        <Toolbar
          role="section"
          className="col-10 col-offset-1 nc_page-header"
          center={sideNavActive ? undefined : <h1>Teachers &amp; Admins</h1>}
          end={
            isAdmin && (
              <div className="flex nc_button-row">
                <Button
                  label="Enroll New Teacher/Admin"
                  icon="nc_icon-nc_add icon-sm"
                  aria-label="Enroll new teacher or adminr"
                  rounded
                  outlined
                  onClick={() => setShowEnrollUserDialog(true)}
                  id="enrollTeacherAdminButton"
                />
              </div>
            )
          }
        />
        {!sideNavActive && (
          <BreadCrumb className="col-10 col-offset-1 nc_breadcrumb" model={breadcrumbItems} home={home} />
        )}
        <div className="col-10 col-offset-1 nc_block">
          <TeachersDataTable
            setSelectedTeacher={setSelectedTeacher}
            refetchTeachertKey={refetchTeacherKey}
            setOpenEnrollTeacher={setShowEnrollUserDialog}
          />
        </div>
        {showEnrollUserDialog && (
          <ClassWizardNewTeacherDialog
            visible={showEnrollUserDialog}
            onHide={() => {
              setShowEnrollUserDialog(false);
              setSelectedTeacher(undefined);
            }}
            siteId=""
            siteName=""
            siteOptions={userRedux?.sites?.map(site => ({ id: site.id || '', name: site.name || '' })) || []}
            teacher={selectedTeacher}
            toast={toast}
            onSaved={() => setRefetchTeacherKey(new Date().getTime())}
          />
        )}
      </div>
    </>
  );
};

export default Teachers;
